// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cgN_","option":"styles_option__18shK","active":"styles_active__2TMLa"};